import React, { Fragment } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CardActionArea,
} from "@mui/material";
import { useQuery } from "react-query";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { getSimulationsData } from "../../services/cluster";
import { grey } from "@mui/material/colors";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { MODULES } from "../../services/Constants";
import useModule from "../../hooks/useModule";
import ClusterSimulationFileUploadDialog from "./ClusterSimulationFileUploadDialog";
import ClusterFileUpload from "./ClusterFileUpload";
import InfoTile from "../common/InfoTile";
import DottedTile from "../common/DottedTile";

const ClusterImageStats = () => {
  const { validateModuleWithMessage } = useModule();
  const { data: { data: { simulations = 0 } = {} } = {} } = useQuery(
    ["getSimulationsReport", { simulationType: "CLUSTER" }],
    getSimulationsData,
    {
      refetchOnWindowFocus: false,
    }
  );

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    width: 800,
    height: 400,
    bgcolor: "background.paper",
    outline: 0,
    p: 4,
  };

  const [openModal, setOpenModal] = React.useState(false);
  const handleOpen = () => {
    if (!validateModuleWithMessage(MODULES.OTA)) return;
    setOpenModal(true);
  };
  const handleClose = () => setOpenModal(false);

  return (
    <Fragment>
      <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} >
        <InfoTile title={"Total Clusters"} info={simulations || "0"} />
      </Grid>
      <Check I={CAN.CREATE} a={SUBJECTS.IMAGE}>
        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} >
          <CardActionArea onClick={handleOpen}>
            <DottedTile title={"UPLOAD NEW SIMULATION"}>
              <CloudUploadIcon sx={{ fontSize: "3.5rem", color: grey[500] }} />
            </DottedTile>
          </CardActionArea>
          {openModal ? (
            <ClusterFileUpload
              uploadType={"CLUSTER"}
              handleClose={handleClose}
              openModal={openModal}
            />
          ) : null}
        </Grid>
      </Check>
    </Fragment>
  );
};

ClusterImageStats.defaultProps = {};

ClusterImageStats.propTypes = {};

export default ClusterImageStats;
